import { Link } from 'react-router-dom'
import suamaLogo from "../assets/images/logo_suama.png"

const Footer = () => {

  const localStorageClear = () => {
    localStorage.clear();
  }

  return (
    <footer>
    <p>動物行動学者監修<br />「うちの子何ねこ？」愛猫診断アプリ</p>
    <div className="footer-link flex-center">
    <Link to="/nanineko/" className="text-link" onClick={ localStorageClear }>診断トップ</Link>
      <span>|</span>
      <Link to="/nanineko/about" className="text-link" onClick={ localStorageClear }>このアプリについて</Link>
    </div>
    <p className="copy">©️Suama</p>
    <a href="https://suama-catscafe.com/" onClick={ localStorageClear }><img src={ suamaLogo } className="logo-suama" /></a>
    <div></div>
  </footer>
  )
}
  
  export default Footer